import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CacheService } from 'src/app/shared/services/cache.service';
import { CoreService } from 'src/app/shared/services/core.service';
import { environment } from 'src/environments/environment';

import urlJoin from 'url-join';
import { BulkOperation } from '../decorators/bulk-operation.decorator';

@Injectable({
  providedIn: 'root',
})
export class AdSpaceService {
  private baseClientUrl = `${environment.API_URL}/media/`;
  constructor(
    private http: HttpClient,
    private router: Router,
    private coreService: CoreService,
    private cache: CacheService,
  ) { }

  public verifyPublisherAdSpaces(params = {}) {
    return this.getAdSpaceList(params)
      .subscribe(async (response: any) => {
        const adSpaces = response.filter((adSpace) => adSpace.status === 'Active');
        if (adSpaces.length === 0) {
          const message = ('You have no approved AdSpaces, please go to your ' +
            'Settings and create one. If you already created one you may have ' +
            'to wait a day until it gets confirmed.');
          const { value } = await this.coreService.alert(
            'Warning',
            message,
            {
              icon: 'warning',
              confirmButtonText: 'Open Settings',
              showCancelButton: false,
              showCloseButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
            },
          );
          if (value) {
            this.router.navigate(['/setting/ad-space']);
          }
        }
      });
  }

  public getAdSpaceList(params = {}, skipCache = false) {
    return this.http.get(this.baseClientUrl, {
      params,
      headers: this.cache.buildCacheSkipHeader(skipCache),
    });
  }

  public getAdSpace(id: number) {
    const url = urlJoin(this.baseClientUrl, `${id}/ `);
    return this.http.get(url);
  }

  public addAdSpace(body) {
    return this.http.post(this.baseClientUrl, body);
  }

  public updateAdSpace(id, body) {
    const url = urlJoin(this.baseClientUrl, `${id}/`);
    return this.http.patch(url, body);
  }

  public getAdspaceCategory() {
    const url = urlJoin(this.baseClientUrl, 'category/');
    return this.http.get(url)
      .toPromise();
  }

  public getAdspaceVertical() {
    const url = urlJoin(this.baseClientUrl, 'vertical/');
    return this.http.get(url)
      .toPromise();
  }

  public getAdspaceTraffic() {
    const url = urlJoin(this.baseClientUrl, 'traffic/');
    return this.http.get(url)
      .toPromise();
  }

  public getAdspaceReach() {
    const url = urlJoin(this.baseClientUrl, 'reach/');
    return this.http.get(url)
      .toPromise();
  }

  @BulkOperation()
  public bulkUpdateAdspace(updates) {
    const url = urlJoin(this.baseClientUrl, 'bulk_update/');
    return this.http.patch(url, { updates });
  }
}
